// Clean "big-rank" card face: large rank top-left with the suit under it, big centre pip, two colours. Drawn by us, no art.
const RANK = { T: "10" };
// suits are drawn, not typed: Mac/iOS swap the ♥♦♣♠ characters for their own (emoji) glyphs, which sized and doubled up
const PATHS = {
  s: "M50 4C38 22 8 40 8 62c0 14 11 24 24 24 7 0 12-3 15-7-1 8-4 13-10 17h26c-6-4-9-9-10-17 3 4 8 7 15 7 13 0 24-10 24-24C92 40 62 22 50 4z",
  h: "M50 92C34 76 6 58 6 34 6 18 18 6 32 6c8 0 14 4 18 11 4-7 10-11 18-11 14 0 26 12 26 28 0 24-28 42-44 58z",
  d: "M50 2 88 50 50 98 12 50z",
  c: "M50 6c-12 0-21 9-21 21 0 6 2 11 6 15-3-2-7-3-11-3C12 39 4 48 4 60s9 21 20 21c8 0 15-4 19-11-1 10-4 16-11 21h36c-7-5-10-11-11-21 4 7 11 11 19 11 11 0 20-9 20-21s-8-21-20-21c-4 0-8 1-11 3 4-4 6-9 6-15 0-12-9-21-21-21z",
};
const Suit = ({ s, size, style }) => (
  <svg viewBox="0 0 100 100" width={size} height={size} className="absolute" style={style} aria-hidden><path d={PATHS[s]} fill="currentColor" /></svg>
);

export const SimpleCard = ({ card, height, className = "", style, ...rest }) => {
  const rank = RANK[card[0]] || card[0];
  const red = card[1] === "h" || card[1] === "d";
  const w = Math.round(height * 0.7);
  const color = red ? "#d61f2c" : "#111827";
  return (
    <div {...rest} className={`simple-card relative select-none ${className}`} style={{ width: w, height, borderRadius: height * 0.08, background: "linear-gradient(160deg,#ffffff 0%,#f3f4f6 100%)", boxShadow: "inset 0 0 0 1.5px rgba(0,0,0,0.18)", color, ...style }}>
      <div className="absolute leading-none font-black" style={{ left: height * 0.07, top: height * 0.04, fontSize: rank === "10" ? height * 0.28 : height * 0.34, fontFamily: "'Arial Black', 'Helvetica Neue', Arial, sans-serif", letterSpacing: rank === "10" ? "-0.06em" : 0 }}>{rank}</div>
      <Suit s={card[1]} size={height * 0.27} style={{ left: height * 0.075, top: height * 0.40 }} />
      <Suit s={card[1]} size={height * 0.3} style={{ right: height * 0.08, bottom: height * 0.08 }} />
    </div>
  );
};

export const deckStyle = () => localStorage.getItem("pfp_deck") || "simple";
